import axios from "axios";
import { APIS } from "../../../../api-factory";
const POST_HEADER = {
  // 'Accept': 'application/json',
  "Content-Type": "application/json",
};


export const getMailTemplateCountApi = (data, callBack, error) => {
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const licenseId =
      data.licenseId !== undefined && data.licenseId !== null
        ? data.licenseId
        : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const type = data.type !== undefined ? data.type : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_MAIL_TEMPLATE_TABLE_COUNT +
          lenderId +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId +
          "&type=" +
          type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getMailTemplateConfigApi = (
    pageNo,
    noOfRows,
    data,
    callBack,
    error
  ) => {
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const licenseId =
      data.licenseId !== undefined && data.licenseId !== null
        ? data.licenseId
        : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const type = data.type !== undefined ? data.type : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_MAIL_TEMPLATE_CONFIG +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&lenderId=" +
          lenderId +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId +
          "&type=" +
          type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getWhatsappTemplateCountApi = (data, callBack, error) => {
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const licenseId = data.licenseId !== undefined ? data.licenseId : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const type = data.type !== undefined ? data.type : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_WHATSAPP_TEMPLATE_TABLE_COUNT +
          lenderId +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId +
          "&type=" +
          type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getWhatsappTemplateConfigApi = (
    pageNo,
    noOfRows,
    data,
    callBack,
    error
  ) => {
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const licenseId = data.licenseId !== undefined ? data.licenseId : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const type = data.type !== undefined ? data.type : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_WHATSAPP_TEMPLATE_CONFIG +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&lenderId=" +
          (lenderId !== null ? lenderId : "") +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId +
          "&type=" +
          type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getTextMsgTemplateCountApi = (data, callBack, error) => {
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const licenseId = data.licenseId !== undefined ? data.licenseId : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const type = data.type !== undefined ? data.type : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_TEXT_MSG_TEMPLATE_TABLE_COUNT +
          lenderId +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId +
          "&type=" +
          type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getTextMsgTemplateConfigApi = (
    pageNo,
    noOfRows,
    data,
    callBack,
    error
  ) => {
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const licenseId = data.licenseId !== undefined ? data.licenseId : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const type = data.type !== undefined ? data.type : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_TEXT_MSG_TEMPLATE_CONFIG +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&lenderId=" +
          lenderId +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId +
          "&type=" +
          type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const CommunityLeadCommunicationApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_COMMUNICATION, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}

export const logsDetailsApiCommunityByUserId = (pageNo, noOfEntry, data, callBack, error) => {
    console.log(data)
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.COM_GET_COMMUNICATION + pageNo + '&noOfEntry=' + noOfEntry + '&type=' + 'l' + '&id=' + data.userId + '&communityId=' + data.communityId + '&lenderId=' + data.lenderId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}

export const logsTotalCountApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_LOGS_TOTAL_COUNT + '' + '&type=' + '1' + '&communityId=' + data.communityId + '&lenderId=' + data.lenderId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}

export const sendNotification = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.ADD_NOTIFICATIONS, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}

export const getWhatsappDataBycommunityIdAdmin = (loanId, communityId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_WHATS_MSG_BY_LOANID + loanId + '&communityId=' + communityId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}
export const getWhatsappDataBylenderIdAdmin = (loanId, lenderId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_WHATS_MSG_BY_LOANID + loanId + '&lenderId=' + lenderId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}

export const getWhatsappDataByUserIdAdmin = (loanId, userId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_WHATS_MSG_BY_LOANID + loanId + '&userId=' + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}
export const getWhatsappmsgByLoanId = (loanId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_WHATS_MSG_BY_LOANID + loanId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}
export const sendWhatsAppMsg = (commentData, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.SEND_WHATSAPP_MSG, commentData, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}

export const uploadWhatsAppDoc = (file, rowData, lenderId, callBack, error) => {
    console.log(file.type)
    const type = file.type === 'image/png' ? 'img' : file.type === 'application/pdf' ? 'pdf' : file.type === 'image/jpg' ? 'img' : file.type === 'image/jpeg' ? 'img' : ''
    const headerConfig = {
        headers: {},
    };
    let multipartFormData = new FormData()
    multipartFormData.append('docName', 'Whatsapp Attachment')
    multipartFormData.append('description', 'Whatsapp Attachment')
    multipartFormData.append('file', file)
    multipartFormData.append('documentId', '')
    multipartFormData.append('type', type)
    multipartFormData.append('fileName', file.name)
    multipartFormData.append('lenderId', lenderId !== '' ? lenderId : "")
    multipartFormData.append('licenseId', rowData.licenseId ? rowData.licenseId : LICENCE_ID)
    multipartFormData.append('userId', rowData.userId !== undefined ? rowData.userId : "")
    multipartFormData.append('loanId', rowData.loanId !== undefined ? rowData.loanId : "")
    multipartFormData.append('communityId', rowData && rowData.communityId ? rowData.communityId : '')
    multipartFormData.append('replaceOrUpload', 0)

    axios.post(APIS.UPLOAD_DOCUMENT_AND_GET_URL, multipartFormData, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })


}


export const getAssignedLenders = (loanId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_ASSIGNED_LENDERS_BY_LOANID + loanId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
        })
}
